import React, { useEffect, useState } from "react";
import styled from "styled-components/macro";
import { Button, Modal } from "@mui/material";
import API from "../../../axios/API";
import ShowBadge from "./ShowBadge";
import useGlobalStore from "@/store/useGlobalStore";
import { SNACK_TYPES } from "@/constants/common";
import { ArrowLeft, ArrowRight } from "react-feather";

const Wrapper = styled.div`
  position: absolute;
  left: 50%;
  top: 50%;
  text-align: center;
  transform: translate(-50%, -50%);
  padding: 20px;
  min-height: 360px;
  width: calc(min(340px, 96vw));
  background: #eeeeee;
  border-radius: 20px;
  max-height: 90vh;
  border: 2px solid black;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
`;

const Inner = ({ data }) => {
  const setSnackText = useGlobalStore((state) => state.setSnackText);
  const clearBadgeData = useGlobalStore((state) => state.clearBadgeData);
  const [index, setIndex] = useState(0);
  const [claiming, setClaiming] = useState(false);

  useEffect(() => {
    setSnackText("You earned a badge 🎉🎉", SNACK_TYPES.SUCCESS);
  }, []);

  const markBadgesAsViewed = async () => {
    setClaiming(true);
    try {
      await API.put("/achievements/new-badges/", {
        viewed_badges: data.new_badges.map((badge) => badge.id),
      });
      setClaiming(false);
      setSnackText(
        "Badges claimed. You can view badges in your profile",
        SNACK_TYPES.SUCCESS,
      );
      clearBadgeData();
    } catch (error) {
      setClaiming(false);
      setSnackText(
        "Error claiming your badges. You can view badges in your profile",
        SNACK_TYPES.ERROR,
      );
      clearBadgeData();
    }
  };

  const hasMultipleBadgesEarned = data?.new_badges?.length > 1;
  const numBadgesEarned = data?.new_badges?.length;
  const activeBadge = data?.new_badges[index];

  return (
    <Wrapper>
      <div
        style={{
          width: "100%",
          padding: 4,
        }}
      >
        <ShowBadge
          badge={activeBadge}
          key={activeBadge.achievement_name}
          nextLevels={data.next_levels}
        />
      </div>
      <>
        {hasMultipleBadgesEarned && (
          <>
            <div style={{ minHeight: 8 }} />
            <span style={{ fontSize: 12, fontWeight: 500 }}>
              <b style={{ fontWeight: 600, color: "black" }}>{index + 1}</b> of{" "}
              <b style={{ fontWeight: 600 }}>{numBadgesEarned}</b>
            </span>
            <div style={{ minHeight: 2 }} />
            <div
              style={{
                padding: 4,
                boxShadow: "0px 0px 1px 1px gainsboro",
                borderRadius: 8,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: 4,
              }}
            >
              <Button
                color="secondary"
                sx={{
                  background: "white",
                  minHeight: 20,
                  minWidth: 20,
                  width: 32,
                }}
                disabled={index === 0}
                onClick={() => setIndex((p) => p - 1)}
              >
                <ArrowLeft height={14} />
              </Button>
              <Button
                color="secondary"
                sx={{
                  background: "white",
                  minHeight: 20,
                  minWidth: 20,
                  width: 32,
                }}
                disabled={index + 1 === numBadgesEarned}
                onClick={() => setIndex((p) => p + 1)}
              >
                <ArrowRight height={14} />
              </Button>
            </div>
          </>
        )}
      </>
      <div style={{ minHeight: 12 }} />
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Button
          color="primary"
          variant="contained"
          size="small"
          disabled={claiming}
          onClick={markBadgesAsViewed}
        >
          Claim {!hasMultipleBadgesEarned ? "Badge" : "Badges"}
        </Button>
      </div>
    </Wrapper>
  );
};

const NewBadgeModal = () => {
  const badgeData = useGlobalStore((state) => state.badgeData);
  return (
    <Modal
      BackdropProps={{
        sx: {
          backgroundColor: "rgba(0, 0, 0, .8)",
        },
      }}
      open={Boolean(badgeData)}
      onClose={() => {}}
    >
      <div>
        <Inner data={badgeData} />
      </div>
    </Modal>
  );
};

export default NewBadgeModal;
